import App from './App.tsx';
export default App; 